"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = function styles(theme) {
  return {
    root: {
      width: 36,
      height: 20,
      padding: 0,
      margin: 0
    },
    switchBase: {
      padding: 2,
      '&$disabled': {
        color: _colors["default"].white,
        '& + $track': {
          backgroundColor: _colors["default"].mainBackground,
          opacity: 1,
          border: 'none'
        }
      },
      '&$checked': {
        transform: 'translateX(16px)',
        color: _colors["default"].white,
        '& + $track': {
          backgroundColor: _colors["default"].turqoise,
          opacity: 1,
          border: 'none'
        }
      }
    },
    thumb: {
      width: 16,
      height: 16
    },
    track: {
      borderRadius: '1000px',
      backgroundColor: _colors["default"].iconLight,
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border'])
    },
    checked: {},
    disabled: {}
  };
};

exports.styles = styles;